import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-c58c8094"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "login-wrap"
};
const _hoisted_2 = {
  class: "holder holder-fluid"
};
const _hoisted_3 = {
  class: "login"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "title"
}, "Подтвердите почту", -1));

const _hoisted_5 = {
  class: "reg-text"
};

const _hoisted_6 = /*#__PURE__*/_createTextVNode("Мы отправили письмо с подтверждением на почту ");

const _hoisted_7 = /*#__PURE__*/_createTextVNode(". Перейдите в свой почтовый ящик и подтвердите его");

const _hoisted_8 = /*#__PURE__*/_createTextVNode("Отправить снова ");

const _hoisted_9 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("p", null, [_hoisted_6, _createElementVNode("span", null, _toDisplayString($options.formattedEmail), 1), _hoisted_7]), _createElementVNode("p", null, [_hoisted_8, $data.time ? (_openBlock(), _createElementBlock("span", _hoisted_9, "через " + _toDisplayString($data.time) + " сек", 1)) : (_openBlock(), _createElementBlock("span", {
    key: 1,
    class: "send-button",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.resend && $options.resend(...args))
  }, "Повторить отправку"))])])])])]);
}